import type { WriteRejection } from "@estelle/domain";

/**
 * Turn one `WriteRejection` into a sentence someone can act on.
 *
 * Same shape as `describeRejection` in `catalog/writeRejection.ts`, kept as
 * its own copy rather than a shared import — module directories stay
 * self-contained, and three other agents are editing sibling modules right
 * now. The `switch` has no `default` on purpose: a sixth rejection kind
 * added to the union in `@estelle/domain` fails this file at compile time
 * instead of silently describing it as nothing.
 */
export function describeRejection(rejection: WriteRejection): string {
  switch (rejection.kind) {
    case "blocked":
    case "channel_rejected":
      return rejection.message;
    case "conflict":
      return `${rejection.message} It changed at ${rejection.currentUpdatedAt}.`;
    case "forbidden":
      return `${rejection.message} (requires ${rejection.permission})`;
    case "invalid":
      return rejection.fields
        ? `${rejection.message} ${Object.entries(rejection.fields)
            .map(([field, problem]) => `${field}: ${problem}`)
            .join("; ")}`
        : rejection.message;
  }
}
